export const ACTIVATE_ACCOUNT = 'ACTIVATE_ACCOUNT'
export const CHECK_TOKEN = 'CHECK_TOKEN'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const GET_AUTH_FROM_TOKEN = 'GET_AUTH_FROM_TOKEN'
export const RESEND_TWO_FACTORS_CODE = 'RESEND_TWO_FACTORS_CODE'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const SAML_CHECK = 'SAML_CHECK'
export const SIGN_IN = 'SIGN_IN'
export const VALIDATE_TWO_FACTORS_CODE = 'VALIDATE_TWO_FACTORS_CODE'
